import { z } from "zod";

/** A calendar month in UTC, `YYYY-MM` (costs and budgets). */
export const CostMonth = z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/, "Month as YYYY-MM");
export type CostMonth = z.infer<typeof CostMonth>;

/** A decimal amount of money, as a string (e.g. `"12.3456"`): never a float on the wire. */
export const Amount = z.string().regex(/^-?\d+(\.\d+)?$/);
export type Amount = z.infer<typeof Amount>;
